{
  "requiredField": "Заполните обязательное поле",
  "firstName": {
    "required": "Имя обязательно для заполнения",
    "invalidChars": "Не должно содержать цифры"
  },
  "lastName": {
    "required": "Фамилия обязательна для заполнения",
    "invalidChars": "Не должно содержать цифры"
  },
  "email": {
    "incorrect": "Некорректный email"
  },
  "phone": {
    "required": "Телефон обязателен для заполнения"
  },
  "password": {
    "required": "Заполните обязательное поле",
    "short": "Пароль должен быть не менее 8 символов",
    "large": "Пароль должен быть не более 64 символов",
    "mismatch": "Пароли не совпадают"
  },
  "terms": {
    "required": "Необходимо согласие с пользовательским соглашением"
  },
  "company": {
    "nameRequired": "Название компании обязательно",
    "typeRequired": "Тип компании обязательно для заполнения",
    "nifRequired": "NIF обязательно для заполнения",
    "regionRequired": "Регион обязательно для заполнения",
    "cityRequired": "Город обязателен для заполнения",
    "activitySpheresRequired": "Сферы деятельности обязательны для заполнения",
    "economicActivitiesRequired": "Сфера экономической деятельности обязательна для заполнения",
    "managerRequired": "Менеджер обязательно для заполнения",
    "descriptionRequired": "Описание компании обязательно для заполнения"
  },
  "vacancy": {
    "nameRequired": "Название вакансии обязательно",
    "regionRequired": "Выберите регион",
    "cityRequired": "Выберите город",
    "candidatesCountRequired": "Выберите количество вакантных мест",
    "responsibleRequired": "Выберите ответственного сотрудника",
    "currencyRequired": "Выберите валюту",
    "descriptionRequired": "Описание обязательно",
    "salaryFromRequired": "Введите минимальную зарплату",
    "salaryToRequired": "Введите максимальную зарплату",
    "salaryMinValue": "Зарплата должна быть больше 0",
    "salaryComparison": "Максимальная зарплата должна быть больше или равна минимальной",
    "requirementsMandatory": "Обязательные требования необходимы",
    "requirementsAdditional": "Дополнительные требования необходимы",
    "responsibilitiesRequired": "Обязанности необходимы",
    "employmentTypesRequired": "Выберите хотя бы один тип занятости",
    "paymentPeriodRequired": "Выберите период выплат",
    "scheduleRequired": "Выберите график работы",
    "skillsRequired": "Выберите хотя бы один навык",
    "activeFromRequired": "Дата начала активности обязательна",
    "activeToRequired": "Дата окончания активности обязательна",
    "interviewFinalMessageRequired": "Сообщение для заинтересовавшихся обязательно",
    "activitySpheresRequired": "Сферы деятельности обязательны для заполнения",
    "tariffRequired": "Выберите тариф"
  },
  "activity": {
    "startDateComprasion": "Дата начала активности должна быть больше или равна текущей дате",
    "typeRequired": "Выберите тип активности",
    "startDateRequired": "Дата начала обязательна при выборе периода",
    "endDateRequired": "Дата окончания обязательна при выборе периода",
    "dateComparison": "Дата окончания должна быть больше даты начала"
  },
  "role": {
    "required": "Группа обязательна для заполнения"
  }
}
